import React, { useEffect, useState } from "react";
import { Col, Table, Container, Button } from "react-bootstrap";
import classes from "../../WebsiteManagement/websiteManagement.module.css";
import { GetAdminHolidayBookings } from "../../../entities/action/action";

const formatOrderDate = (orderDate) => {
  if (!orderDate) return "—";
  const d = new Date(orderDate);
  if (Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()} ${d.toLocaleTimeString()}`;
};

const HolidayData = (props) => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const res = await GetAdminHolidayBookings();
        if (cancelled) return;
        if (res?.success && Array.isArray(res.bookings)) {
          setBookings(res.bookings);
        } else {
          setBookings([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Container fluid style={{ marginTop: "5vh" }}>
      <Col lg={12} md={12} className={classes.Response2}>
        {loading ? (
          <p>Loading holiday bookings…</p>
        ) : (
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Booking Date and Time</th>
                <th>Reference ID</th>
                <th>Package Name</th>
                <th>Travel Date</th>
                <th>Phone Number</th>
                <th>Booking Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {bookings.length ? (
                bookings.map((row, key) => (
                  <tr key={row.bookingId || key}>
                    <td>{key + 1}</td>
                    <td>{formatOrderDate(row.orderDate)}</td>
                    <td>{row.bookingRef || "—"}</td>
                    <td>{row.packageName || "—"}</td>
                    <td>{row.travelDate || "—"}</td>
                    <td>{row.phone || "—"}</td>
                    <td>{row.status || "—"}</td>
                    <td>
                      <div className={classes.Center}>
                        <Button variant="danger" onClick={() => props.click(row)}>
                          View
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8}>No holiday bookings found</td>
                </tr>
              )}
            </tbody>
          </Table>
        )}
      </Col>
    </Container>
  );
};

export default HolidayData;
